import confirmDialogInstance from "~/composables/useConfirmDialog";
import loadingOverlayInstance from "~/composables/useLoadingOverlay";

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.provide("confirmDialog", confirmDialogInstance);
  nuxtApp.provide("loadingOverlay", loadingOverlayInstance);
});
